<template>
  <div :class="`products ${isMobile ? 'products-mobile' : ''}`">
    <div class="box">
      <img class="bk" src="./resources/bk.jpg" />
      <div class="products-carousel">
        <Carousel :height="`${bodyHeight * (1920 / 1502) * (1502 / 1214)}px`" :autoplay="true" indicator-position="none" arrow="never">
          <CarouselItem v-for="path in images" :key="path">
            <img :src="path" alt="carousel" />
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, CarouselItem } from 'element-ui';
import { _isMobile } from '@/utils/config';

export default {
  name: 'products',
  // 与父组件通信
  props: {},
  // 组件
  components: { Carousel, CarouselItem },
  // 数据
  data() {
    return {
      isMobile: _isMobile(),
      bodyHeight: 0,
      images: [
        require('./resources/aries.png'),
        require('./resources/drying_rack.png'),
        require('./resources/switch01.png'),
        require('./resources/switch03-02.png'),
        require('./resources/switch03.png'),
        require('./resources/table_lamp.png'),
      ],
    };
  },
  // 监听
  watch: {},
  // 挂载结束状态
  mounted() {
    this.bodyHeight = document.body.clientHeight;
  },
  // 方法
  methods: {},
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
